import { IHospital } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { HospitalWorkItem } from 'src/app/business/institution/hospital-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class HospitalCommandHandler extends EntityCommandHandler<IHospital> {
  protected workItem: IWorkItem<IHospital>;

  constructor(hospitalWorkItem: HospitalWorkItem) {
    super();
    this.workItem = hospitalWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'HospitalDto';
  }
}
